<template>
    <div class="new-report-label-input__container" ref="inputContainerRef" :data-is-sticky="isSticky">
        <span class="new-report-label-input__button" @click="onSearchButtonClick"> 
            <template v-if="!isAutocompleteVisible">
                <SearchSvgIcon />
            </template>
            <template v-else>
                <CloseSvgIcon />
            </template>
        </span>
        <input class="new-report-label-input"
            @keydown="onKeyDown" 
            ref="inputElementRef"
            @focus="onFocus"
            @blur="onBlur"
            type="text" v-model="labelText" 
            placeholder="Digite aqui para inserir um novo termo" />

        <labelAutocompletePanel ref="autocompletePanel" :filterReportNodes="false" :searchText="labelText" :filterLayerId="null" :show="isAutocompleteVisible" 
            @select="selectNode" @onTotalResultsChange="onTotalResultsChange" />
    </div>
</template>

<script>
import { evtBus } from '@/main';
import { gConsts } from '@/globals/gConsts';
import labelAutocompletePanel from './autocomplete/labelAutocompletePanel.vue';
import { mapActions } from 'vuex';

import SearchSvgIcon from '@/assets/icons/search.svg';
import CloseSvgIcon from '@/assets/icons/close.svg';

export default {
    name: 'newReportLabelInput',
    components: {
        labelAutocompletePanel,
        SearchSvgIcon,
        CloseSvgIcon,
    },
    props: {
        isSticky: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            labelText: '',
            totalResults: 0,
            isFocused: false,
            showSearchPanel: false,
        }
    },
    methods: {
        ...mapActions([
            'ACT_reportNodes_addNewLabelReportText',
        ]),

        selectNode(node) {
            // console.log('selectNode', node);
            this.labelText = '';
            this.showSearchPanel = false;
            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: node.id, nodeType: gConsts.node.layout.types.LABEL });
            this.ACT_reportNodes_addNewLabelReportText({ labelId: node.id });
            this.$refs.inputElementRef.blur();
        },

        onFocus() {
            this.isFocused = true;
        },

        onBlur(event) {
            setTimeout(() => {
                this.isFocused = false;
            }, 250);
        },

        onKeyDown(event) {
            if (event.key === 'ArrowDown') {
                event.preventDefault();
                evtBus.$emit('evt_labelAutocomplete_action', 'cursorMove', { direction: 'next' });
            } else if (event.key === 'ArrowUp') {
                event.preventDefault();
                evtBus.$emit('evt_labelAutocomplete_action', 'cursorMove', { direction: 'previous' });
            } else if (event.key === 'Enter') {
                event.preventDefault();
                evtBus.$emit('evt_labelAutocomplete_action', 'cursorSelectTerm');
            } else if (event.key === 'Escape') {
                event.preventDefault();
                this.labelText = '';
                this.showSearchPanel = false;
            }
        },

        onSearchActionEvent(searchTerm) {
            if (this.$refs.inputElementRef) {
                this.$refs.inputElementRef.focus();
                this.showSearchPanel = true;
            }   
        },

        onSearchButtonClick() {
            if (this.showSearchPanel || this.labelText.length > 0) {
                this.reset();
            } else {
                this.showSearchPanel = true;
            }
        },

        onTotalResultsChange(totalResults) {
            this.totalResults = totalResults.search;
        },

        reset() {
            this.labelText = '';
            this.isFocused = false;
            this.showSearchPanel = false;
        },

        configurePanelInputRef() {
            if (this.$refs.autocompletePanel) {
                this.$refs.autocompletePanel.setInputElementRef(this.$refs.inputContainerRef);
            }
        },
    },
    computed: {
        isAutocompleteVisible() {
            if (this.showSearchPanel)
                return true;
            return this.labelText.length > 0 && this.isFocused;
        }
    },

    mounted() {
        evtBus.$on('evt_labelSearchAction', (source, payload) => {
            this.onSearchActionEvent(payload.searchTerm ?? '');
        });

        evtBus.$on('evt_labelSearchPopup_close', this.reset);

        this.$nextTick(() => {
            this.configurePanelInputRef();
        });
    }

}
</script>

<style scoped>
.new-report-label-input__container {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    width: 100%;
}
.new-report-label-input__container[data-is-sticky="true"] {
    position: sticky;
    bottom: 0;
    width: auto;
    padding: var(--spacing-md);
    background-color: var(--background-white);
    border-top: 1px solid var(--border-primary);
    z-index: 1;
}

/* .new-report-label-input__container:focus-within .new-report-label-input {
    outline: none;
    border-color: var(--color-dark-gray);
}

.new-report-label-input__container:hover .new-report-label-input {
    border-color: var(--color-dark-gray);
} */

.new-report-label-input {
    width: 100%;
    padding: var(--spacing-xs) 0;
    outline: none;
    border: none;
    font-size: var(--text-sm);
    font-family: var(--font-family-primary);
    color: var(--color-secondary);
    border-bottom: 1px solid transparent;
}

.new-report-label-input__button {
    display: flex;
    color: var(--color-dark-gray);
    border-radius: var(--radius-md);
    padding: var(--spacing-xs);
    flex-shrink: 0;
    cursor: pointer;
}

.new-report-label-input__button:hover {
    color: var(--color-primary);
    background-color: var(--background-light-gray);
}

.new-report-label-input__button>svg {
    width: 18px;
    height: 18px;
}

</style>